// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/organisations/organisation.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest, EmptyResponse } from "../../common/messages/messages";
import { GetAllOrganisationsResponse, Organisation } from "./organisation";

import { OrganisationServiceClientImpl } from "./organisation";

@Injectable({ providedIn: "root" })
export class OrganisationServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async getAllOrganisations(request: EmptyRequest): Promise<GetAllOrganisationsResponse> {
    const client = new OrganisationServiceClientImpl(this._rpc);
    return await client.getAllOrganisations(request);
  }
  async updateOrganisation(request: Organisation): Promise<EmptyResponse> {
    const client = new OrganisationServiceClientImpl(this._rpc);
    return await client.updateOrganisation(request);
  }
}
